export default __webpack_public_path__ + "static/media/statistic-img.c8fdd17d.png";